export default __webpack_public_path__ + "static/media/1_pav_OSMOS CENERE_120x120_riv_OSMOS RUGGINE_60x120_Matt.95be21ed.jpg";